import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@e2n/ui';
import VertraegeCard from '@/domain/vertraege/features/VertragCarousel/card/VertraegeCard';
import { UpgradeVertragCard } from '@/domain/vertraege/features/VertragCarousel/UpgradeVertragCard/UpgradeVertragCard';
import { useVertraege } from '@/domain/vertraege/shared/hooks/useVertraege';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function VertragCarousel() {
  const { vertraege } = useVertraege();
  const { t } = useTranslation();

  return (
    <Carousel className="flex justify-center items-center mx-10">
      <CarouselContent>
        {vertraege?.map((vertrag) => (
          <CarouselItem key={vertrag.id}>
            <div className="flex justify-center items-center gap-16 h-full p-4">
              <WithFeatureFlags name="vertraege-2" Fallback={<></>}>
                {!vertrag.hasAktuellesVertragsmodell() && (
                  <UpgradeVertragCard vertrag={vertrag} />
                )}
              </WithFeatureFlags>
              <div className="flex flex-col gap-4 justify-center items-center text-sm text-neutrals-800 w-[400px] h-full">
                <VertraegeCard vertrag={vertrag} />
                {vertrag.hasAktuellesVertragsmodell() && (
                  <div>
                    {t('domain.vertraege.banner.title')}{' '}
                    {t('domain.vertraege.banner.subtitle')}{' '}
                    <a
                      className="text-sm font-semibold text-primary-blue-600"
                      href="https://e2n.de/backoffice/"
                      rel="noreferrer"
                      target="_blank">
                      {t('domain.vertraege.banner.buttonText')}
                      <FontAwesomeIcon icon={faArrowUpRight} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious variant="outline-secondary" />
      <CarouselNext variant="outline-secondary" />
    </Carousel>
  );
}
